module.exports = __webpack_public_path__ + "assets/img/dti.cb261e6e.jpg";